import { render, staticRenderFns } from "./AccountGroupOutline.vue?vue&type=template&id=6ffd195e"
import script from "./AccountGroupOutline.vue?vue&type=script&lang=js"
export * from "./AccountGroupOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports